import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";

const User_shiftvoter = () => {
  const { id } = useParams();
  const [licenseData, setLicenseData] = useState({
    fullName: "",
    gender: "",
    dateOfBirth: "",
    mobileNumber: "",
    email: "",
    birthState: "",
    birthDistrict: "",
    relation: "",
    relationName: "",
    relationAddress: "",
    relationPincode: "",
    livingAddressSince: "",
    oldVoterIDNumber: '',
    previousConstituencyState: '',
    previousConstituency: '',
    submitNote: "",
    completedNote: "",
    Status: "In-Progress",
    rejectedNote: "",
    statusHistory: "",// Ensure rejectedNote is included
  });
  const [documents, setDocuments] = useState({
    aadharCard: null,
    panCard: null,
    photo: null,
    signature: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState({});
  const [showDocument, setShowDocument] = useState(null);
  const statusEnum = ["In-Progress", "Submitted", "Rejected", "Completed"];
  const navigate = useNavigate(); // Use navigate to redirect
  // Access auth state from context

  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        const response = await axios.get(
          `https://api.makeeasydocuments.com/api/shiftVoterID/getShiftVoterID/${id}`
        );
        const data = response.data;
        console.log(response.data);
        setLicenseData({
          fullName: data.fullName || "",
          gender: data.gender || "",
          dateOfBirth: data.dateOfBirth || "",
          mobileNumber: data.mobileNumber || "",
          email: data.email || "",
          birthState: data.birthState || "",
          birthDistrict: data.birthDistrict || "",
          relation: data.relation || "",
          relationName: data.relationName || "",
          relationAddress: data.relationAddress || "",
          relationPincode: data.relationPincode || "",
          livingAddressSince: data.livingAddressSince || "",
          oldVoterIDNumber: data.oldVoterIDNumber || '',
          previousConstituencyState: data.previousConstituencyState || '',
          previousConstituency: data.previousConstituency || '',
          submitNote: data.submitNote || "",
          completedNote: data.completedNote || "",
          Status: data.Status || "In-Progress",
          rejectedNote: data.rejectedNote || "",
          createdAt: data.createdAt || "",
          updatedAt: data.updatedAt || "",
          documents: data.documents || {},
          statusHistory: data.statusHistory || "",
        });
      } catch (err) {
        setError("Error fetching license data", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseData();
  }, [id]);

  const handleUpdate = async (event) => {
    event.preventDefault();

    // Update the Status to "In-Progress"
    const updatedLicenseData = { ...licenseData, Status: "In-Progress" };
    const formData = new FormData();

    for (const key in updatedLicenseData) {
      if (updatedLicenseData.hasOwnProperty(key)) {
        // Skip the documents and user objects
        if (key !== "documents" && key !== "user") {
          // Handle dates specially
          if (updatedLicenseData[key] instanceof Date) {
            formData.append(key, updatedLicenseData[key].toISOString());
          }
          // Handle primitive values
          else if (typeof updatedLicenseData[key] !== "object") {
            formData.append(key, updatedLicenseData[key]);
          }
        }
      }
    }

    // If you need to send the user ID, send it properly
    if (updatedLicenseData.user && updatedLicenseData.user._id) {
      formData.append("user", updatedLicenseData.user._id);
    }

    console.log("User Data:", licenseData.user);
    console.log("Updated Status:", updatedLicenseData.Status);

    // Append files to formData
    for (const [key, value] of Object.entries(files)) {
      if (value instanceof File) {
        formData.append(`documents.${key}`, value);
      }
    }

    // Log the FormData content for debugging
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    console.log("User Data:", licenseData.user);
    console.log("Updated Status:", updatedLicenseData.Status);



    try {

      const response = await axios.put(
        `https://api.makeeasydocuments.com/api/shiftVoterID/updateShiftVoterID/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("after put", response.data); // Log the response data
      showCustomToast(response.data.message);
      setTimeout(() => {
        navigate("/dashboard/my_application");
      }, 4001);
    } catch (error) {
      console.log("Error updating FreshPassport:", error);
      showCustomToast("Failed to update license.", "error");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLicenseData({ ...licenseData, [name]: value });
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: files[0],
    }));
  };
  const renderImage = (imageData) => {
    try {
      // Check if all required properties exist and are valid
      if (
        imageData &&
        imageData.contentType &&
        imageData.data &&
        imageData.data.data &&
        Array.isArray(imageData.data.data)
      ) {
        const byteArray = new Uint8Array(imageData.data.data);
        const base64String = btoa(
          Array.from(byteArray)
            .map(byte => String.fromCharCode(byte))
            .join('')
        );
        return `data:${imageData.contentType};base64,${base64String}`;
      }
      console.log("Invalid image data:", imageData);
      return null;
    } catch (error) {
      console.error("Error rendering image:", error);
      return null;
    }
  };
  const DocumentPreviewModal = ({ document, onClose }) => {
    if (!document) return null;

    // Check if document is a string (URL) or an object
    const documentUrl = typeof document === 'string' ? document : null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full">
          <h2>Download The Documents From Here...</h2>

          {documentUrl && (
            <div className="my-4">
              <img
                src={documentUrl}
                className="max-w-full max-h-96 mx-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ""; // Placeholder for failed image load
                  // e.target.alt = "Unable to preview document";
                }}
              />
            </div>
          )}

          <div className="mt-4 flex justify-between">
            <button
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
              onClick={onClose}
            >
              Close
            </button>
            {documentUrl && (

              <a href={documentUrl}
                download
                className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
              >
                Download
              </a>
            )}
          </div>
        </div>
      </div>
    );
  };

  const DownloadableDocuments = () => {
    console.log("License Data Documents:", licenseData.documents); // Debug log
    if (!licenseData.documents) return null; // Ensure documents is defined

    const { receipt, finisheddoc } = licenseData.documents;

    const status = licenseData.Status;

    return (
      <div className="col-span-3 bg-white shadow-md p-6 rounded-lg mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Downloadable Documents
        </h2>
        {(status === "Submitted" || status === "Completed") && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {status === "Submitted" || status === "Completed" ? (
              <div className="border p-4 rounded-lg text-center bg-gray-50">
                <h3 className="font-semibold mb-2">Receipt</h3>
                <button
                  className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                  onClick={() => {
                    const imageUrl = renderImage(receipt);
                    setShowDocument(imageUrl);
                  }}
                >
                  View Receipt
                </button>
              </div>
            ) : (
              <div className="hidden sm:block"></div> // Placeholder to maintain layout
            )}
            {status === "Completed" && finisheddoc ? (
              <div className="border p-4 rounded-lg text-center bg-gray-50">
                <h3 className="font-semibold mb-2">Finished Document</h3>
                <button
                  className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                  onClick={() => setShowDocument(renderImage(finisheddoc))}
                >
                  View Document
                </button>
              </div>
            ) : (
              <div className="hidden sm:block"></div> // Placeholder to maintain layout
            )}
          </div>
        )}
      </div>
    );
  };

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-red-500">{error}</div>;
  if (!licenseData) return <div>No data found</div>;

  const labelClass = "block text-sm mb-2 font-medium text-gray-700";
  const inputClass = "border border-gray-300 rounded-md p-2 w-full";

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden">
          <div className="px-4 py-5 sm:p-6">
            <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">
              Shift Voter Card
            </h1>
            <DownloadableDocuments />
            <form onSubmit={handleUpdate} className="space-y-6">
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                {/* Personal Information Section */}
                <div className="col-span-3">
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    Personal Information
                  </h2>
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                    <div>
                      <label htmlFor="fullName" className={labelClass}>
                        Full Name
                      </label>
                      <input
                        type="text"
                        id="fullName"
                        name='fullName'
                        className={inputClass}
                        value={licenseData.fullName}
                        onChange={handleInputChange}
                        placeholder="Enter full name"
                        required
                        disabled={!licenseData || licenseData.Status !== "Rejected"}
                      />
                    </div>

                    <div>
                      <label htmlFor="gender" className={labelClass}>
                        Gender
                      </label>
                      <select
                        id="gender"
                        className={inputClass}
                        value={licenseData.gender}
                        onChange={handleInputChange} // Missing onChange handler
                        name='gender'
                        required
                        disabled={!licenseData || licenseData.Status !== "Rejected"}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div>
                      <label htmlFor="dateOfBirth" className={labelClass}>
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        id="dateOfBirth"
                        name='dateOfBirth'
                        className={inputClass}
                        value={licenseData.dateOfBirth}
                        onChange={handleInputChange}
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="mobileNumber" className={labelClass}>
                        Mobile Number
                      </label>
                      <input
                        type="number"
                        id="mobileNumber"
                        name='mobileNumber'
                        className={inputClass}
                        value={licenseData.mobileNumber}
                        onChange={handleInputChange}
                        placeholder="Enter mobile number"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className={labelClass}>
                        Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        className={inputClass}
                        value={licenseData.email}
                        name='email'
                        onChange={handleInputChange}
                        placeholder="Enter email"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="birthState" className={labelClass}>
                        Birth State
                      </label>
                      <input
                        type="text"
                        id="birthState"
                        className={inputClass}
                        name='birthState'
                        value={licenseData.birthState}
                        onChange={handleInputChange}
                        placeholder="Enter birth state"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="birthDistrict" className={labelClass}>
                        Birth District
                      </label>
                      <input
                        type="text"
                        id="birthDistrict"
                        className={inputClass}
                        name='birthDistrict'
                        value={licenseData.birthDistrict}
                        onChange={handleInputChange}
                        placeholder="Enter birth district"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>
                    <div>
                      <label htmlFor="relation" className={labelClass}>
                        Relation
                      </label>
                      <input
                        type="text"
                        id="relation"
                        className={inputClass}
                        name='relation'
                        value={licenseData.relation}
                        onChange={handleInputChange}
                        placeholder="Enter relation"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="relationName" className={labelClass}>
                        Relation Name
                      </label>
                      <input
                        type="text"
                        id="relationName"
                        name='relationName'
                        className={inputClass}
                        value={licenseData.relationName}
                        onChange={handleInputChange}
                        placeholder="Enter relation name"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="relationAddress" className={labelClass}>
                        Relation Address
                      </label>
                      <input
                        type="text"
                        id="relationAddress"
                        name='relationAddress'
                        className={inputClass}
                        value={licenseData.relationAddress}
                        onChange={handleInputChange}
                        placeholder="Enter relation address"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label htmlFor="relationPincode" className={labelClass}>
                        Relation Pincode
                      </label>
                      <input
                        type="text"
                        id="relationPincode"
                        className={inputClass}
                        name='relationPincode'
                        value={licenseData.relationPincode}
                        onChange={handleInputChange}
                        placeholder="Enter relation pincode"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>
                    {/* living address since  */}
                    <div>
                      <label htmlFor="livingAddressSince" className={labelClass}>
                        living Address Since
                      </label>
                      <input
                        type="date"
                        id="livingAddressSince"
                        className={inputClass}
                        name='livingAddressSince'
                        value={licenseData.livingAddressSince}
                        onChange={handleInputChange}
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>


                    <div>
                      <label htmlFor="oldVoterIDNumber" className={labelClass}>
                        Old Voter ID Number
                      </label>
                      <input
                        type="text"
                        id="oldVoterIDNumber"
                        className={inputClass}
                        name='oldVoterIDNumber'
                        value={licenseData.oldVoterIDNumber}
                        onChange={handleInputChange}
                        placeholder="Enter old Voter ID number"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="previousConstituencyState"
                        className={labelClass}
                      >
                        Previous Constituency State
                      </label>
                      <input
                        type="text"
                        id="previousConstituencyState"
                        className={inputClass}
                        name='previousConstituencyState'
                        value={licenseData.previousConstituencyState}
                        onChange={handleInputChange}
                        placeholder="Enter previous constituency state"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="previousConstituency"
                        className={labelClass}
                      >
                        Previous Constituency
                      </label>
                      <input
                        type="text"
                        id="previousConstituency"
                        className={inputClass}
                        name='previousConstituency'
                        value={licenseData.previousConstituency}
                        onChange={handleInputChange}
                        placeholder="Enter previous constituency"
                        required
                        disabled={licenseData.Status !== "Rejected"} // Disable if Status is not "Rejected"
                      />
                    </div>
                  </div>
                </div>
                {/* Document Upload Section */}
                <div className="col-span-3">
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    Documents
                  </h2>
                  <div className="space-y-4">
                    <div className="flex space-x-4">
                      <div className="flex-1">
                        <label className={labelClass} htmlFor="aadharCard">
                          Aadhar Card
                        </label>
                        <input
                          id="aadharCard"
                          name="aadharCard"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"

                        />
                      </div>

                      <div className="flex-1">
                        <label className={labelClass} htmlFor="panCard">
                          Pan Card
                        </label>
                        <input
                          id="panCard"
                          name="panCard"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"

                        />
                      </div>

                      <div className="flex-1">
                        <label className={labelClass} htmlFor="photo">
                          Photo
                        </label>
                        <input
                          id="photo"
                          name="photo"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"

                        />
                      </div>
                    </div>

                    <div className="flex space-x-4">
                      <div className="flex-1">
                        <label className={labelClass} htmlFor="signature">
                          Signature
                        </label>
                        <input
                          id="signature"
                          name="signature"
                          type="file"
                          className={inputClass}
                          accept="image/*"
                          onChange={handleFileChange}
                          disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"

                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Application History */}
                <div className="col-span-3 bg-green-50 shadow-md p-6 rounded-lg w-full lg:w-full space-y-4">
                  <h2 className="text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
                    Application History
                  </h2>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Created At (Date & Time):
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {new Date(licenseData.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </div>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Updated At (Date & Time):
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.updatedAt
                        ? new Date(licenseData.updatedAt).toLocaleString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          }
                        )
                        : "N/A"}
                    </span>
                  </div>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Current Status:
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.Status ? licenseData.Status : "N/A"}
                    </span>
                  </div>

                  {/* history */}
                  {/* Display history regardless of Status */}
                  <div className="flex justify-between text-gray-800">
                    <div className="text-gray-600 flex-1">
                      <strong className="text-gray-600">Status History:</strong>
                    </div>

                    {/* Display for new schema with statusHistory */}
                    {licenseData.statusHistory && licenseData.statusHistory.length > 0 ? (
                      <div className="flex-1 text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                        {licenseData.statusHistory.map((statusChange, index) => (
                          <div
                            key={index}
                            className={`p-3 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-b border-gray-300 last:border-b-0`}
                          >
                            <div className="flex justify-between items-center mb-1">
                              <span className="text-sm font-medium text-gray-500">
                                Changed on: {new Date(statusChange.changedAt).toLocaleString()}
                              </span>
                              <span className={`text-xs font-semibold px-2 py-1 rounded ${statusChange.status === 'Rejected' ? 'bg-red-100 text-red-800' :
                                statusChange.status === 'Submitted' ? 'bg-blue-100 text-blue-800' :
                                  statusChange.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                    'bg-yellow-100 text-yellow-800'
                                }`}>
                                {statusChange.status}
                              </span>
                            </div>
                            <p className="text-gray-700">{statusChange.note || "No additional notes"}</p>
                          </div>
                        ))}
                      </div>
                    ) : (
                      // Fallback for when no status history exists
                      <div className="text-center text-gray-500 border border-gray-300 bg-gray-50 p-3 rounded">
                        No status history available
                      </div>
                    )}
                  </div>
                </div>

                {licenseData.Status === "Rejected" && (
                  <div>
                    <button
                      type="submit"
                      className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                    >
                      Update Application
                    </button>
                  </div>
                )}
              </div>
            </form>
            <DocumentPreviewModal
              document={showDocument}
              onClose={() => setShowDocument(null)}
            />

            <CustomToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default User_shiftvoter;
